import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import BuildersDesigners from "@/pages/BuildersDesigners";
import CarePlans from "@/pages/CarePlans";
import Contact from "@/pages/Contact";

function Layout({ children }) {
  return (
    <SmoothScroll>
      <div className="App text-white">
        <Navbar />
        <main>{children}</main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#111115", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", borderRadius: 0 } }} />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/builders-designers" element={<BuildersDesigners />} />
          <Route path="/care-support" element={<CarePlans />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
